<template>
    <TopNav></TopNav>
		<h1>Tax Calculator</h1>
		<fieldset>
      <legend>Tax Calculator</legend>
      <input type="radio" name="f" value="cc" id="cc" v-model="selectedCalculation"><label for="cc">Find price before tax by entering total price with tax</label><br>
      <input type="radio" name="f" value="dc" id="dc" v-model="selectedCalculation"><label for="dc">Find total price with tax by entering price before tax</label><br>
      <input type="radio" name="f" value="ec" id="ec" v-model="selectedCalculation"><label for="ec">Find price before tax by entering tax</label><br>
      <br>
      <label for="ii">Tax %</label><input type="number" name="o" id="ii" v-model.number="oran" step="any">
      <br>
      <label for="bi">{{ text() }}</label><input type="number" v-model.number="inputB" id="bi" step="any"><br>
      <br>
      Price Before Taxes: <span class="blue">${{ kdvharictutar() }}</span><br>
      Tax: <span class="blue">${{ kdvtutar() }}</span><br>
      Total Price With Tax: <span class="blue">${{ kdvdahiltutar() }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Tax",
  data() {
    return {
      inputB: 100,
      selectedCalculation: "cc",
      oran: 18
    }
  },
  components: {
    TopNav
  },
  methods: {
    text: function () {
      if (this.selectedCalculation === "cc") {
        return "Total Price With Tax $";
      } else if (this.selectedCalculation === "dc") {
        return "Price Before Taxes $";
      } else {
        return "Tax $";
      }
    },
    kdvharictutar: function () {
      if (this.selectedCalculation === "cc") {
        var tplmkdv = 100 + this.oran;
        var brmkdv = this.inputB / tplmkdv;
        var kdvtutar = this.oran * brmkdv;
        return (this.inputB - kdvtutar).toFixed(2);
      }
      if (this.selectedCalculation === "dc") {
        return this.inputB;
      }
      if (this.selectedCalculation === "ec") {
        var yuzdebiroran = this.inputB / this.oran;
        return (yuzdebiroran * 100).toFixed(2);
      }
    },
    kdvtutar: function () {
      if (this.selectedCalculation === "cc") {
        var tplmkdv = 100 + this.oran;
        var brmkdv = this.inputB / tplmkdv;
        return (this.oran * brmkdv).toFixed(2);
      }
      if (this.selectedCalculation === "dc") {
        return ((this.inputB / 100) * this.oran).toFixed(2);
      }
      if (this.selectedCalculation === "ec") {
        return (this.inputB).toFixed(2);
      }
    },
    kdvdahiltutar: function () {
      if (this.selectedCalculation === "cc") {
        return this.inputB;
      }
      if (this.selectedCalculation === "dc") {
        return ((this.inputB / 100) * this.oran) + this.inputB;
      }
      if (this.selectedCalculation === "ec") {
        var yuzdebiroran = this.inputB / this.oran;
        var yuzdeyuz = yuzdebiroran * 100;
        return (yuzdeyuz + this.inputB).toFixed(2);
      }
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label[for$="i"] {
  display: inline-block;
  min-width: 195px;
}

input[name="f"] {
  position: absolute;
}

input[name="f"] ~ label[for$="c"] {
  padding-left: 1.4em;
  display: inline-block;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
